import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  bpb_id: '',
  bpb_date: '',
  equip_id: '',
  crane_id: '',
  operator_nik: '',
  operator: '',
  employee_nik: '',
  employee: '',
  bpb_jenisperbaikan: '',
  jenis_perbaikan: '',
  bpb_keterangan: '',
  keterangan: '',
  bpb_fotoform: '',
  foto_bpb: '',
  bps_id: '',
  rowid: '',
  detail: [],
  log: [],
  record: {
    created_by: '',
    created_date: '',
    modified_by: '',
    modified_date: '',
  },
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
  detailTab: 0,
  selectedDetailId: null,
};

const ops07bpbSlice = createSlice({
  name: 'ops07bpb',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDetailTab: (state, action) => { state.detailTab = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setSelectedDetailId: (state, action) => { state.selectedDetailId = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
      state.selectedDetailId = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
      state.detailTab = 0;
      state.selectedDetailId = null;
    },
  },
});

export const {
  setActiveTab,
  setDetailTab,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  setSelectedDetailId,
  updateFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  clearModuleState,
} = ops07bpbSlice.actions;

export default ops07bpbSlice.reducer;
